import * as React from "react";
import { useClientId } from "./ClientConfig";
import { resolveProductionClientId } from "./client-features";

export const PantheonOnly: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <SomeClientsOnly clientIds={["pantheon"]}>{children}</SomeClientsOnly>;

export const SomeClientsOnly: React.FC<{
  clientIds: string[];
  children: React.ReactNode;
}> = ({ clientIds, children }) => {
  const clientId = resolveProductionClientId(useClientId());
  return clientId && clientIds.includes(clientId) ? <>{children}</> : null;
};
